import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";
import { IAddSubject, ISubject } from "../../Subject.props";

const useEditSubject = (subjectId: string,setSelectedSubjectId:any) => {
  const [formData, setFormData] = useState<IAddSubject>({
    languageName: "",
    courseName: "",
    standard: "",
    subject :"",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [courses, setCourses] = useState<any[]>([]);
  const [languages, setLanguages] = useState<any[]>([]);
  const [subjectName, setSubjectName] = useState<any[]>([]);
  const [standard, setStandard] = useState<any[]>([]);
  const navigate = useNavigate();

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.getSubject}/${subjectId}`,
      });
      console.log("Fetched Subject Data:", response); // Log the fetched subject data
      populateFormData(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const populateFormData = (subjectData: ISubject) => {
    setFormData({
      languageName: subjectData.languageName,
      courseName: subjectData.courseName,
      standard: subjectData.standard,
      subject: subjectData?.subject,
    });
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>
  ) => {
    const { id, type, value } = e.target;

    if (type === "file") {
      const files = (e.target as HTMLInputElement).files;

      if (files && files.length > 0) {
        setFormData((prev) => ({
          ...prev,
          [id]: files[0], // Store the first file
        }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [id]: value, // Store the value for select and input elements
      }));
    }
  };

  const fetchCoursesAndLanguages = async () => {
    try {
      setLoading(true);
      const [coursesResponse, languagesResponse, standardResponse] =
        await Promise.all([
          ApiService({ method: "GET", endpoint: apiPaths.getCourse}),
          ApiService({ method: "GET", endpoint: apiPaths.getlanguage }),
          ApiService({ method: "GET", endpoint: apiPaths.getStandard }),
        ]);
      setCourses(coursesResponse || []);
      setLanguages(languagesResponse || []);
      setStandard(standardResponse || []);

      if (!coursesResponse.length || !languagesResponse.length) {
        toast.error("No data found for courses or languages.");
      }
    } catch (error) {
      console.error("Error fetching courses and languages:", error);
      toast.error("Failed to fetch courses or languages.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit: SubmitHandler<IAddSubject> = async (data) => {
    console.log("OINSIDSDJBVSFBJxs")
    setLoading(true);
    try {
      await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.updateSubject}/${subjectId}`,
        data: formData,
      });
      toast.success("Subject updated successfully!");
      // setSelectedSubjectId(null)
      window.location.reload();
    } catch (error) {
      console.error("Error updating subject:", error);
      toast.error("Failed to update subject.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCoursesAndLanguages();
    fetchData();
  }, [subjectId]);

  const handleCancel = () => {
    setSelectedSubjectId(null)
  };

  return {
    formData,
    loading,
    languages,
    courses,
    subjectName,
    standard,
    handleChange,
    handleSubmit,
    handleCancel,
  };
};

export default useEditSubject;
